



































import Vue from 'vue';
import { IProduct } from '@/common/interfaces/products.interface';
import config from '../../../config';
import OldFormatHelper from '../../helpers/OldFormatHelper';
import ProductListPriceDisplay from './ProductListPriceDisplay.vue';
import ProductHelper from '@/helpers/ProductHelper';

export default Vue.extend({
  name: `ProductListDetails`,
  components: { ProductListPriceDisplay },
  data(): { ProductHelper: typeof ProductHelper} {
    return {
      ProductHelper,
    };
  },
  props: {
    discountActive: {
      required: true,
      type: Boolean,
    },
    hasMultipleCarts: {
      required: true,
      type: Boolean,
    },
    isPartner: {
      required: true,
      type: Boolean,
    },
    mode: {
      required: true,
      type: String,
    },
    product: {
      required: true,
      type: Object as () => IProduct,
    },
  },
  methods: {
    getAdditionalUnit(): string {
      if(this.product.basePrice.brutto && this.product.unitPriceAmount && this.product.unitPriceType && this.product.unitPriceAmount > 0) {
        const { text, unitPriceType } = ProductHelper.formatAdditionalUnitPrice(this.product, { amount: this.product.unitPriceAmount, type: this.product.unitPriceType }, this.isPartner);
        return text.replaceAll(`{{unitPriceType}}`, this.$t(unitPriceType));
      }
      return ``;
    },
    getBasePriceText(product: IProduct): string {
      let response = ``;
      if(config.products.unitContentsIds.includes(product.unitContentsId)) {
        response = `${product.contentsAmount} ${this.$t(product.unitContents ?? ``)} (${OldFormatHelper.getPrice(product.basePrice.brutto, product.currency)} / ${product.basePrice.amount} ${this.$t(product.basePrice.unit ?? ``)})`;
      }
      return response;
    },
    hasBasePrice(product: IProduct): boolean {
      for(const value of Object.values(product.basePrice)) {
        if(value === null) {
          return false;
        }
      }
      return true;
    },
  },
});
